import './App.css'
import Episodes from './components/Episodes/Episodes'
import Blurb from './components/Blurb/Blurb'


function App(props) {
  return (
    <div className="App" data-layer-region="rookie-moment">
      <Episodes selectedEpisode={props.selectedEpisode} episodes={[...props.episodes]} />

      <Blurb {...props.content} />

    </div>
  )
}

export default App
